/* spinner-container.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./spinner-container.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var spinnerContainerStyles = null;

/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */
var SpinnerContainer = function SpinnerContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1bsb1ejb _ahbqpxbi"])
  }, children);
};
export default SpinnerContainer;